export const WidgetCustomizationFile = {
  pc: 'configuration',
  sp: 'configuration-sp',
} as const;
export type WidgetCustomizationFile =
  typeof WidgetCustomizationFile[keyof typeof WidgetCustomizationFile];
